import { Popover } from 'antd';
import { IPopoverProps } from './entities';

const arrowDefaultValue = { pointAtCenter: true };

const BCPopover = (props: IPopoverProps) => {
	return (
		<Popover
			arrow={arrowDefaultValue}
			{...props}
		/>
	);
};

export default BCPopover;
